module.exports = __webpack_public_path__ + "static/Jan Szczepkowski w gronie kolegów (1914 r.)-99f88f8fd5ef6ee58c96e65e17817563.jpg";